// Drive a turbo frame through a real link click, rather than setting frame.src.
//
// Two reasons the synthetic link matters on the events toolbar:
//   1. A bare frame.src assignment does not promote to a Turbo advance, so the
//      address bar never updates and the resulting view isn't shareable. A real
//      click does, honouring the frame's data-turbo-action.
//   2. It sends `Turbo-Frame: <id>`, which is how Events::FilterPersistable
//      recognises a filter/sort surface applying a selection — and therefore
//      how an empty selection is read as "cleared" rather than "restore what I
//      remembered".
//
// Falls back to a full navigation when the frame isn't on the page.
export function navigateFrame(frameId, href) {
  if (!document.getElementById(frameId)) {
    window.location.href = href
    return
  }

  const link = document.createElement("a")
  link.href = href
  link.dataset.turboFrame = frameId
  document.body.appendChild(link)
  link.click()
  link.remove()
}
